import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/Toaster";
import { UserHeader } from "./UserLayoutHeader";
import "./style.css"; // Custom styles if needed
import { useSelector } from "react-redux";
import { RootState } from "@/app/store";
import { getCurrentDateTime } from "@/components/remote-user/user-portal/ServiceCard";

const UserDashboardLayout: React.FC = () => {
  const { time, date } = getCurrentDateTime();
  const userData = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const { userInfo } = useSelector((state: RootState) => state.auth);
  return (
    <div className="font-poppins bg-outletcolor flex h-full w-full">
      {/* Main content area */}
      <div className="flex-1 w-full h-screen">
        {/* Sticky header container */}
        <div className="sticky top-0 z-20 bg-outletcolor w-full">
          <UserHeader
            userName={`${userInfo?.first_name ?? userData.first_name} ${userInfo?.last_name ?? userData.last_name}`}
            userId={userData.id}
          />
        </div>

        {/* Scrollable main content */}
        <main className=" h-full max-h-[calc(100vh-120px)]">
          {" "}
          {/* Adjust max-height here */}
          <div className="w-full h-fit  bg-outletcolor ">
            <Outlet />
            <Toaster />
          </div>
        </main>
      </div>
    </div>
  );
};

export default UserDashboardLayout;
